import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse } from 'antd';

import { useScrollToTop } from 'shared/lib/useScrollToTop';
import {
	FAQContainer,
	FAQHeading,
	FAQListStyled,
	FAQSubheading,
	FAQText,
	QuestionHeader,
	QuestionsContainer,
	SupportTextStyled,
} from './FAQ.styles';

import './FAQ.css';

export const FAQ: FC = () => {
	const getHeaderStyled = (text: string): JSX.Element => <QuestionHeader>{text}</QuestionHeader>;

	const { t } = useTranslation();

	useEffect(() => {
		document.title = `FAQ`;
	}, []);

	useScrollToTop();

	return (
		<FAQContainer>
			<FAQHeading>{t(`Marketplace_FAQ_Heading`)}</FAQHeading>
			<QuestionsContainer ghost>
				<Collapse.Panel header={getHeaderStyled(t(`Marketplace_FAQ_Q1_Q`))} key='1'>
					<FAQText>{`${t(`Marketplace_FAQ_Q1_A_1`)}\n\n${t(`Marketplace_FAQ_Q1_A_2`)}`}</FAQText>
				</Collapse.Panel>
				<Collapse.Panel header={getHeaderStyled(t(`Marketplace_FAQ_Q2_Q`))} key='2'>
					<FAQText>
						У каждого приложения свой тарифный план, с ним можно ознакомиться на странице приложений.
						<br />
						Приложения, разработанные Управляющей компанией Dodo Brands будут доступны бесплатно.
					</FAQText>
				</Collapse.Panel>
				<Collapse.Panel header={getHeaderStyled(`Как подключить платное приложение?`)} key='3'>
					<FAQText>
						Для подключения платного приложения перейдите на его страницу в маркетплейсе и выберите
						подходящий тариф. Оформите подписку в роли Администратора подразделения. <br />
						Завершающим этапом подключите приложение к своей сети.
						<br />
						<br />
						Подключить приложение смогут следующие роли:
						<FAQListStyled>
							<li>Центральный менеджер офиса</li>
							<li>Администратор подразделения</li>
							<li>Менеджер офиса</li>
						</FAQListStyled>
					</FAQText>
				</Collapse.Panel>
				<Collapse.Panel header={getHeaderStyled(`Как оплатить подписку?`)} key='4'>
					<FAQText>
						Во время оформления подписки ничего оплачивать не нужно, она активируется с момента
						подтверждения покупки. В первый день месяца ваша бухгалтерия получит счет на оплату через
						систему электронного документооборота. В течение 5 дней вам необходимо оплатить счет за
						подписку.
					</FAQText>
				</Collapse.Panel>
				<Collapse.Panel header={getHeaderStyled(t(`Marketplace_FAQ_Q3_Q`))} key='5'>
					<FAQText>{t(`Marketplace_FAQ_Q3_A`)}</FAQText>
				</Collapse.Panel>
				<Collapse.Panel header={getHeaderStyled(t(`Marketplace_FAQ_Q4_Q`))} key='6'>
					<FAQListStyled>
						<li>
							{t(`Marketplace_FAQ_Q4_A_1`)}
							<a href='https://docs.dodois.io/' target='_blank' rel='noreferrer'>
								API Dodo IS
							</a>
						</li>
						<li>{t(`Marketplace_FAQ_Q4_A_2`)}</li>
						<li>{t(`Marketplace_FAQ_Q4_A_3`)}</li>
						<li>{t(`Marketplace_FAQ_Q4_A_4`)}</li>
					</FAQListStyled>
				</Collapse.Panel>
				<Collapse.Panel header={getHeaderStyled(t(`Marketplace_FAQ_Q5_Q`))} key='7'>
					<FAQText>
						{t(`Marketplace_FAQ_Q5_A`)}
						<a href='mailto:support@dodopizza.com'>support@dodopizza.com.</a>
					</FAQText>
				</Collapse.Panel>
			</QuestionsContainer>
			<FAQSubheading>{t(`Marketplace_FAQ_Subheading`)}</FAQSubheading>
			<SupportTextStyled>
				{t(`Marketplace_FAQ_Support_Text`)}
				<a href='mailto:support@dodopizza.com'>support@dodopizza.com</a>
			</SupportTextStyled>
		</FAQContainer>
	);
};
